import React, { createContext, useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import { authQueryKey } from '../api/queries'
import { queryCurrentUser } from '../api/queries'
import { fromAxiosError, useGlobalError } from './GlobalError'
import { IUser } from '../api/types/user'

const Context = createContext<IUser | undefined>(undefined)

const { Provider } = Context

export const useAuth = () => useContext(Context)

interface Props {
  children: any
}

export const AuthProvider: React.FC<Props> = ({ children }) => {
  const { addError } = useGlobalError()

  const { data: auth } = useQuery<IUser>(
    authQueryKey(),
    () => {
      if (localStorage.access) {
        return queryCurrentUser()
      }
      return new Promise(() => null)
    },
    {
      onError: (err: any) => {
        const e = fromAxiosError(err)
        addError(e?.message, e?.status)
      },
    }
  )

  return <Provider value={auth}>{children}</Provider>
}
